import {
  BankOutlined,
  CloseOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Row,
  Select,
  Space,
  Steps,
  Tag,
  Tooltip,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useEffect, useState } from 'react'
import { blue, redPrimary, yellowPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import MainModal from '../../../components/Common/MainModal'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../../constants'
import utils from '../../../utils'
import { SelectList, SelectTitle } from './PopupAddPersonWorkStyled'
import authenticationStore from '../../../stores/authenticationStore'
import {
  CustomStepIcon,
  StepsWrapper,
} from '../../Documents/InternalDocumentSignDocPage/PopupCreateSignDoc/PopupCreateSignDocStyled'

const { Step } = Steps
const { Option } = Select

const PopupAddPersonWork = props => {
  const {
    isVisibleAddPersonWork,
    handleCloseAddPersonWork,
    selectPeopleStore,
    workStore,
    loadingAnimationStore,
    authenticationStore,
  } = props

  const { workDetail, workList } = workStore
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore
  const { assignees, work_type } = workDetail

  const { currentUser } = authenticationStore

  const [form] = Form.useForm()

  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [leaderList, setLeaderList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [departmentApproverList, setDepartmentApproverList] = useState([])
  const [formApproverList, setFormApproverList] = useState([])
  const [leaderApproverList, setLeaderApproverList] = useState([])
  const [numberIssuerList, setNumberIssuerList] = useState([])
  const [digitalSignerList, setDigitalSignerList] = useState([])
  const [releaserList, setReleaserList] = useState([])
  const [permission, setPermission] = useState([
    ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
    ASSIGNEE_TYPE.FORM_APPROVER,
    ASSIGNEE_TYPE.LEADER_APPROVER,
    ASSIGNEE_TYPE.NUMBER_ISSUER,
    ASSIGNEE_TYPE.DIGITAL_SIGNER,
    ASSIGNEE_TYPE.RELEASER,
  ])
  const [stepsData, setStepsData] = useState([])

  useEffect(() => {
    const allSteps = [
      {
        key: 1,
        title: 'Tạo dự thảo',
        userList: currentUser
          ? [
              {
                image_id: currentUser.imageId,
                full_name: currentUser.name_lowercase,
              },
            ]
          : [],
        allowDeleted: false,
      },
      {
        key: 2,
        title: 'Trưởng phòng duyệt',
        userList: departmentApproverList || [],
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
        permission: 'DEPARTMENT_APPROVER',
      },
      {
        key: 3,
        title: 'Duyệt thể thức',
        userList: formApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
        permission: 'FORM_APPROVER',
      },
      {
        key: 4,
        title: 'Lãnh đạo duyệt',
        userList: leaderApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
        permission: 'LEADER_APPROVER',
      },
      {
        key: 5,
        title: 'Cấp số',
        userList: numberIssuerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
        permission: 'NUMBER_ISSUER',
      },
      {
        key: 6,
        title: 'Ký số điện tử',
        userList: digitalSignerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        permission: 'DIGITAL_SIGNER',
      },
      {
        key: 7,
        title: 'Phát hành',
        userList: releaserList || [],
        type: 'approval',
        allowDeleted: false,
        assignee_type: ASSIGNEE_TYPE.RELEASER,
        permission: 'RELEASER',
      },
    ]

    const filteredSteps = allSteps.filter(
      step => !step.permission || permission.includes(step.permission)
    )

    setStepsData(filteredSteps)
  }, [
    releaserList,
    currentUser,
    departmentApproverList,
    formApproverList,
    leaderApproverList,
    numberIssuerList,
    digitalSignerList,
    permission,
  ])

  const userList = assignees
    ? assignees.filter(
        el =>
          el.assignee_type === ASSIGNEE_TYPE.USER &&
          el.permission !== ASSIGNEE_TYPE.CREATE
      )
    : []
  const departmentList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT)
    : []
  const groupList = assignees
    ? assignees.filter(el => el.assignee_type === ASSIGNEE_TYPE.GROUP)
    : []

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
    setCombinerList([...selectUserData[ASSIGNEE_TYPE.COMBINER]])
    setLeaderList([...selectUserData[ASSIGNEE_TYPE.LEADER]])
    setDepartmentApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
    ])

    setFormApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
    ])

    setLeaderApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
    ])

    setNumberIssuerList([
      ...(selectUserData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
    ])

    setDigitalSignerList([
      ...(selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
    ])

    setReleaserList([
      ...(selectUserData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.RELEASER] || []),
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (!isVisibleAddPersonWork) return

    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userList)
      )
    }

    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentList)
      )
    }

    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupList)
      )
    }

    if (workDetail.due_date) {
      form.setFieldsValue({
        due_date: moment(workDetail.due_date),
      })
    } else {
      form.setFieldsValue({
        due_date: undefined,
      })
    }
  }, [originDepartmentWithUserList])

  const workDetailDueDate = workDetail.due_date

  const handleCancel = useCallback(async () => {
    if (workDetailDueDate) {
      await form.setFieldsValue({
        due_date: moment(workDetailDueDate),
      })
    }
    await selectPeopleStore.clearSelected()
    handleCloseAddPersonWork()
  }, [form, handleCloseAddPersonWork, selectPeopleStore, workDetailDueDate])

  const isElectronicWork = work_type === WORK_STATUS.ELECTRONIC

  const handleSubmit = useCallback(async () => {
    const code_work = workDetail?.code
    const new_items_assign = []
    const remove_items_assign = []
    const startDate = workDetail?.start_date
    const dueDate = form.getFieldValue('due_date')
    if (startDate && dueDate && dueDate.isBefore(startDate)) {
      return message.info('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
    }
    const listAssignOrigin = [...userList, ...departmentList, ...groupList].map(
      el => ({
        assignee_code: el.assignee_code,
        assignee_type: el.assignee_type,
        permission: el.permission,
      })
    )
    const listAssignAfter = isElectronicWork
      ? [
          ...departmentApproverList,
          ...formApproverList,
          ...leaderApproverList,
          ...numberIssuerList,
          ...digitalSignerList,
          ...releaserList,
        ].map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))
      : [...followerList, ...handlerList, ...combinerList, ...leaderList].map(
          el => ({
            assignee_code: el.id,
            assignee_type: el.assignee_type,
            permission: el.permission,
          })
        )
    const listAssignAfterNoDuplicates = listAssignAfter.filter(
      (el, index, self) =>
        index === self.findIndex(t => t.assignee_code === el.assignee_code)
    )

    if (!isElectronicWork) {
      if (handlerList.length === 0) {
        return message.info('Bạn chưa chọn người xử lý!')
      }
    }

    if (isElectronicWork) {
      listAssignAfter.forEach(assignAfter => {
        if (
          !listAssignOrigin.some(
            assignOrigin =>
              assignOrigin.assignee_code + assignOrigin.permission ===
              assignAfter.assignee_code + assignAfter.permission
          )
        ) {
          new_items_assign.push({
            assignee_code: assignAfter.assignee_code,
            assignee_type: assignAfter.assignee_type,
            permission: assignAfter.permission,
          })
        }
      })
    } else {
      listAssignAfterNoDuplicates.forEach(assignAfter => {
        if (
          !listAssignOrigin.some(
            assignOrigin =>
              assignOrigin.assignee_code + assignOrigin.permission ===
              assignAfter.assignee_code + assignAfter.permission
          )
        ) {
          new_items_assign.push({
            assignee_code: assignAfter.assignee_code,
            assignee_type: assignAfter.assignee_type,
            permission: assignAfter.permission,
          })
        }
      })
    }

    listAssignOrigin.forEach(assignOrigin => {
      if (
        !listAssignAfterNoDuplicates.some(
          assignAfter =>
            assignAfter.assignee_code + assignAfter.permission ===
            assignOrigin.assignee_code + assignOrigin.permission
        )
      ) {
        remove_items_assign.push({
          assignee_code: assignOrigin.assignee_code,
          assignee_type: assignOrigin.assignee_type,
          permission: assignOrigin.permission,
        })
      }
    })

    const permission = stepsData
      .filter(el => el.key !== 1)
      .map(el => el.permission)
      .join(',')

    try {
      loadingAnimationStore.showSpinner(true)
      const dataSubmit = {
        new_items: new_items_assign,
        remove_items: remove_items_assign,
        due_date: form.getFieldValue('due_date'),
        permission: permission,
      }
      await workStore.updatePeopleInvole(code_work, dataSubmit)
      const responseDetail = await workStore.getWorkDetail(code_work)
      const parentId = utils.getParameterByName('parent_id')
      if (parentId) {
        await workStore.getListSubWork(responseDetail.data.code)
      } else {
        const newWorkList = [...workList]
        const indexParentTarget = workList.findIndex(
          item => item.code === code_work
        )
        newWorkList[indexParentTarget] = {
          ...responseDetail.data,
          has_subwork: responseDetail.data?.subwork?.length > 0,
        }
        workStore.setWorkList(newWorkList)
      }
      selectPeopleStore.clearSelected()
      handleCloseAddPersonWork()
      message.success('Thêm người thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    departmentList,
    followerList,
    form,
    groupList,
    handlerList,
    handleCloseAddPersonWork,
    leaderList,
    loadingAnimationStore,
    selectPeopleStore,
    userList,
    workList,
    workStore,
    isElectronicWork,
  ])

  const handleRemoveStep = useCallback(
    key => {
      const newStepsData = stepsData.filter(step => step.key !== key)
      setStepsData(newStepsData)
      setPermission(
        newStepsData.filter(el => el.key !== 1).map(el => el.permission)
      )
    },
    [stepsData]
  )

  const existingStepKeys = useCallback(() => {
    return stepsData.map(step => step.key)
  }, [stepsData])

  const allSteps = [
    {
      key: 1,
      title: 'Tạo dự thảo',
      userList: currentUser
        ? [
            {
              image_id: currentUser.imageId,
              full_name: currentUser.name_lowercase,
            },
          ]
        : [],
      allowDeleted: false,
    },
    {
      key: 2,
      title: 'Trưởng phòng duyệt',
      userList: departmentApproverList ? departmentApproverList : [],
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      permission: 'DEPARTMENT_APPROVER',
    },
    {
      key: 3,
      title: 'Duyệt thể thức',
      userList: formApproverList ? formApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
      permission: 'FORM_APPROVER',
    },
    {
      key: 4,
      title: 'Lãnh đạo duyệt',
      userList: leaderApproverList ? leaderApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
      permission: 'LEADER_APPROVER',
    },
    {
      key: 5,
      title: 'Cấp số',
      userList: numberIssuerList ? numberIssuerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
      permission: 'NUMBER_ISSUER',
    },
    {
      key: 6,
      title: 'Ký số điện tử',
      userList: digitalSignerList ? digitalSignerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
      permission: 'DIGITAL_SIGNER',
    },
    {
      key: 7,
      title: 'Phát hành',
      userList: releaserList ? releaserList : [],
      type: 'approval',
      allowDeleted: false,
      assignee_type: ASSIGNEE_TYPE.RELEASER,
      permission: 'RELEASER',
    },
  ]

  const handleAddStep = useCallback(
    key => {
      if (!key) return
      const stepToAdd = allSteps.find(step => step.key === key)
      if (stepToAdd) {
        const updatedSteps = prev => {
          const newSteps = [...prev, stepToAdd]
          newSteps.sort((a, b) => a.key - b.key)
          setPermission(
            newSteps.filter(el => el.key !== 1).map(el => el.permission)
          )
          return newSteps
        }

        setStepsData(updatedSteps)
      }
    },
    [allSteps]
  )

  const renderTitleStep = level => {
    return (
      <>
        <div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>{level.title}</span>
            {level.key !== 1 && (
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ marginLeft: 8 }}
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(level.assignee_type)
                  }
                />
              </Tooltip>
            )}
          </div>
        </div>
      </>
    )
  }

  const renderDescStep = level => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: level.allow_edit ? 6 : 14,
          marginBottom: 14,
        }}>
        {level.userList[0] ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag
              className={'tag-selected'}
              color={'blue'}
              closable={level.key === 1 ? false : true}
              onClose={() =>
                selectPeopleStore.handleRemoveSelect(level.userList[0])
              }>
              <AvatarHasName
                imgId={level.userList[0]?.image_id}
                size={22}
                name={level.userList[0]?.full_name}
              />
            </Tag>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag style={{ borderRadius: 10 }}>Chưa gán người!</Tag>
          </div>
        )}
      </div>
    )
  }

  return (
    <div>
      {isVisibleAddPersonWork && (
        <MainModal
          width={isElectronicWork ? 1000 : 800}
          title="Thêm người"
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          isVisible={isVisibleAddPersonWork}>
          {isElectronicWork ? (
            <>
              <div>
                <Select
                  placeholder="Chọn bước để thêm"
                  value={null}
                  onChange={value => {
                    handleAddStep(value)
                  }}
                  style={{ width: 300 }}>
                  {allSteps
                    .filter(item => item.allowDeleted)
                    .map(step => (
                      <Option
                        key={step.key}
                        value={step.key}
                        disabled={existingStepKeys().includes(step.key)}>
                        {step.title}
                      </Option>
                    ))}
                </Select>
              </div>

              <StepsWrapper count={stepsData.length} i={4}>
                <Steps
                  status="process"
                  className={'steps'}
                  labelPlacement={'vertical'}
                  size={'small'}>
                  {stepsData.map(level => {
                    return (
                      <Step
                        key={level.level}
                        title={renderTitleStep(level)}
                        description={renderDescStep(level)}
                        icon={
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}>
                            <CustomStepIcon>{level.key} </CustomStepIcon>
                            {level.allowDeleted && (
                              <CloseOutlined
                                style={{ marginLeft: 6, fontSize: 12 }}
                                onClick={() => handleRemoveStep(level.key)}
                              />
                            )}
                          </div>
                        }
                      />
                    )
                  })}
                </Steps>
              </StepsWrapper>
            </>
          ) : (
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <SelectTitle>
                  <span>
                    <span
                      style={{
                        color: '#ff4d4f',
                        fontFamily: 'SimSun, sans-serif',
                        marginRight: '-4px',
                      }}>
                      *{' '}
                    </span>
                    <span style={{ marginRight: '10px' }}>
                      {isElectronicWork ? 'Lãnh đạo ký duyệt:' : 'Người xử lý:'}
                    </span>
                  </span>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() =>
                          handleOpenSelectUserDepartmentPopup(
                            ASSIGNEE_TYPE.HANDLER
                          )
                        }
                      />
                    </Tooltip>
                    {!isElectronicWork && (
                      <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                        <Button
                          icon={<TeamOutlined />}
                          style={{ color: yellowPrimary }}
                          onClick={() =>
                            handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                          }
                        />
                      </Tooltip>
                    )}
                  </Space>
                </SelectTitle>
                <SelectList>
                  {handlerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>

              <Col span={12}>
                <SelectTitle>
                  <span>
                    <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
                  </span>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() =>
                          handleOpenSelectUserDepartmentPopup(
                            ASSIGNEE_TYPE.FOLLOWER
                          )
                        }
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={() =>
                          handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                        }
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {followerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>
            </Row>
          )}
          <Row>
            <Form form={form} layout="vertical">
              <Form.Item
                label={'Ngày kết thúc:'}
                name={'due_date'}
                rules={[
                  {
                    required: false,
                    message: 'Vui lòng chọn ngày kết thúc!',
                  },
                  ({}) => ({
                    validator(_, value) {
                      const workDetailStartDate = workDetail.start_date
                      if (!workDetailStartDate || !value) {
                        //! Không thực hiện kiểm tra nếu workDetail.start_date hoặc ngày kết thúc không có giá trị
                        return Promise.resolve()
                      }
                      if (value.isAfter(workDetailStartDate)) {
                        //! Ngày kết thúc lớn hơn workDetail.start_date
                        return Promise.resolve()
                      }
                      //! Ngày kết thúc không hợp lệ
                      return Promise.reject(
                        'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                      )
                    },
                  }),
                ]}>
                <DatePicker format={DATE_FORMAT_LIST} />
              </Form.Item>
            </Form>
          </Row>
          {isElectronicWork ? (
            <SelectPeoplePopup
              onlyOneUser
              handleCancelSelectUser={handleCancelSelectUserDepartment}
              handleSubmitSelectUser={() =>
                setIsVisibleSelectUserDepartmentPopup(false)
              }
              isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
            />
          ) : (
            <SelectPeoplePopup
              onlyOneUser={
                isElectronicWork
                  ? selectPeopleStore.assigneePopupType ===
                    ASSIGNEE_TYPE.HANDLER
                  : false
              }
              handleCancelSelectUser={handleCancelSelectUserDepartment}
              handleSubmitSelectUser={() =>
                setIsVisibleSelectUserDepartmentPopup(false)
              }
              isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
            />
          )}

          <SelectGroupPopup
            onlyOneUser
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
            handleCancelSelectGroup={handleCancelSelectGroup}
            handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
          />
        </MainModal>
      )}
    </div>
  )
}

PopupAddPersonWork.propTypes = {}

export default inject(
  'workStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(PopupAddPersonWork))
